import { AlignJustify, LogOut, Settings, ChevronLeft } from "lucide-react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Sidebar1() {
    const [isExpanded, setIsExpanded] = useState(window.innerWidth > 768);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsExpanded(!isExpanded);
    };

    // Responsive adjustment on window resize
    useEffect(() => {
        const handleResize = () => {
            const isSmallScreen = window.innerWidth <= 768;
            setIsMobile(isSmallScreen);
            setIsExpanded(!isSmallScreen); // Expanded on desktop, collapsed on mobile
        };

        handleResize(); // Run on initial load
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Color palette
    const colors = {
        primary: "#154c79",
        secondary: "#0a2640",
        accent: "#2d7fc1",
        light: "#e9f2fb",
        dark: "#0a1622",
        white: "#ffffff"
    };

    return (
        <>
            {/* Sidebar Container */}
            <div
                style={{
                    fontFamily: "Montserrat, sans-serif",
                    backgroundColor: colors.dark,
                    boxShadow: "0 0 15px rgba(0,0,0,0.2)"
                }}
                className={`h-full fixed top-0 left-0 transition-all duration-300 ease-in-out flex flex-col justify-between z-40 ${
                    isExpanded ? "w-64" : "w-16"
                }`}
            >
                {/* Toggle + Header */}
                <div className="flex flex-col mt-4">
                    <div className="flex items-center px-4 mt-2">
                        {isExpanded ? (
                            <>
                                <ChevronLeft
                                    onClick={() => navigate(-1)}
                                    className="text-white cursor-pointer text-2xl hover:-translate-x-1 transition-transform"
                                />
                                <h1 className="text-white text-xl font-semibold mx-auto">
                                    Company
                                </h1>
                            </>
                        ) : (
                            <ChevronLeft
                                onClick={() => navigate(-1)}
                                className="text-white mx-auto cursor-pointer text-2xl hover:-translate-x-1 transition-transform"
                            />
                        )}

                        <AlignJustify
                            onClick={toggleSidebar}
                            className={`text-white text-2xl cursor-pointer ml-auto ${
                                isExpanded ? "" : "mx-auto"
                            } hover:translate-x-1 transition-transform`}
                        />
                    </div>

                    {/* User Profile */}
                    {isExpanded && (
                        <div
                            className="relative flex items-center mx-0 mt-6 px-2 h-14 rounded-r-full w-60"
                            style={{
                                background: `linear-gradient(90deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                            }}
                        >
                            <h4 className="text-white px-1 flex-1 text-center font-medium">
                                John Doe
                            </h4>
                            <div className="relative">
                                <img
                                    src="/images/person.jpg"
                                    alt="Profile"
                                    className="w-12 h-12 border-2 rounded-full transition-all duration-300 hover:shadow-lg"
                                    style={{ borderColor: colors.light }}
                                />
                            </div>
                        </div>
                    )}

                    {/* Sidebar Navigation */}
                    <nav
                        className={`mt-10 flex flex-col items-center space-y-2 ${
                            !isExpanded ? "pointer-events-none opacity-50" : ""
                        }`}
                    >
                        {[
                            { name: "Edit Profile", path: "/SignIn" },
                            { name: "System Settings", path: "/SettingsPage" }
                        ].map((item, index) => (
                            <div key={index} className="relative w-full flex flex-col items-center group">
                                <Link
                                    to={item.path}
                                    className="text-white text-center w-full py-2 transition relative hover:bg-gradient-to-r from-black via-[#2d7fc1] to-black"
                                >
                                    {isExpanded && (
                                        <span className="relative">
                      {item.name}
                                            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-white transition-opacity duration-300 opacity-0 group-hover:opacity-100"></span>
                    </span>
                                    )}
                                </Link>
                            </div>
                        ))}
                    </nav>
                </div>

                {/* Bottom Section */}
                <div className="flex flex-col items-center mb-5 space-y-4">
                    <Link to="/SettingsPage">
                        <Settings className="text-white w-6 h-6 cursor-pointer transition-transform duration-300 hover:rotate-45" />
                    </Link>
                    {isExpanded && (
                        <div
                            className="w-40 h-0.5 shadow-md"
                            style={{ backgroundColor: colors.accent }}
                        ></div>
                    )}
                    <LogOut className="text-white w-6 h-6 cursor-pointer transition-transform duration-300 hover:translate-x-1" />
                </div>
            </div>
        </>
    );
}

export default Sidebar1;
